export default "__VITE_ASSET__CJ0iBsXe__"